export default {
  EMAIL: 'email',
  PHONE: 'phone',
  ORDER: 'order_number',
  ZIP: 'zip_code',
  GIFT_ZIP: 'gift_zip_code',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name'
};
